import React from 'react';

class ErrorBoundary extends React.Component {
	state = { hasError: false, errorInfo: null };
	style = {
		scaffold: {
			width: '100%',
			display: 'block',
			textAlign: 'center',
		},
		errorInfo: {
			textAlign: 'left',
			marginLeft: '10vmax',
			whiteSpace: 'pre-wrap',
			wordWrap: 'break-word',
		},
		header: {
			marginBottom: '7vmin',
		},
	};
	static getDerivedStateFromError(error) {
		// Update state so the next render will show the fallback UI.
		return { hasError: true, errorInfo: error };
	}
	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div style={this.style.scaffold}>
					<h1 style={this.style.header}>Something went wrong.</h1>
					<pre style={this.style.errorInfo}>{this.state.errorInfo}</pre>
				</div>
			);
		}
		return this.props.children;
	}
}
export default ErrorBoundary;
